import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCustomerService,
  CustomerCompanyInfoModel,
  CustomerAddressRequest,
  CustomerCompanyDetailsUpdateRequest,
  CustomerModel,
  PageModelAuditModel,
  AnyValueModelBigDecimal,
  PageModelCustomerModel,
  CustomerListRequest,
  AnyValueModelCurrency,
  AnyValueModelLanguage,
  AnyValueModelUnitSystemType,
  BaseUserDataModel
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCustomerApiService {
  constructor(private apiService: AdministrationCustomerService) {}

  public updateCustomerAddress(customerId: string, body: CustomerAddressRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.adminCustomerCompanyInfoAddress(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public updateCustomerCompanyDetails(customerId: string, body: CustomerCompanyDetailsUpdateRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.adminCustomerCompanyInfoCompanyDetails(customerId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomerCompanyInfo(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerCompanyInfoModel> {
    return this.apiService.adminCustomerCompanyInfoGet(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomer(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CustomerModel> {
    return this.apiService.adminCustomerGet(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomerAudit(customerId: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAuditModel> {
    return this.apiService.adminCustomerGetAudit(customerId, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCustomerMargin(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AnyValueModelBigDecimal> {
    return this.apiService.adminCustomersGetMargin(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCustomers(body: CustomerListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelCustomerModel> {
    return this.apiService.adminCustomersList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCustomerCurrency(customerId: string, anyValueModelCurrency: AnyValueModelCurrency, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomersSetCurrency(customerId, anyValueModelCurrency, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCustomerLanguage(customerId: string, anyValueModelLanguage: AnyValueModelLanguage, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomersSetLanguage(customerId, anyValueModelLanguage, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCustomerMargin(customerId: string, anyValueModelBigDecimal: AnyValueModelBigDecimal, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomersSetMargin(customerId, anyValueModelBigDecimal, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setCustomerUnit(customerId: string, anyValueModelUnitSystemType: AnyValueModelUnitSystemType, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomersSetUnit(customerId, anyValueModelUnitSystemType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public switchCustomerCountry(customerId: string, enabled: boolean, value: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCustomersSwitchCountry(customerId, enabled, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCustomerUsers(customerId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<BaseUserDataModel[]> {
    return this.apiService.adminCustomersUsersList(customerId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
